const translations = {
    // Header
    home: "首页",
    mail: "邮件",
    calendar: "日历",
    chat: "聊天",
    cart: "购物车",
    tickets: "票据",
    video: "视频",
    aboutUs: "关于我们",
    vendor: "供应商",
    price: "价格",
    pictures: "图片",
    downloadApp: "下载应用",
    menu: "菜单",
    quickActions: "快速操作",
    language: "语言",

    // Common
    close: "关闭",
    cancel: "取消",
    save: "保存",
    delete: "删除",
    edit: "编辑",
    add: "添加",
    search: "搜索",
    submit: "提交",
    loading: "加载中...",
    error: "错误",
    success: "成功",
    confirm: "确认",
    yes: "是",
    no: "否",
    back: "返回",
    next: "下一步",
    previous: "上一步",
    view: "查看",
    details: "详情",
    filter: "筛选",
    reset: "重置",
    export: "导出",
    import: "导入",
    print: "打印",
    download: "下载",
    upload: "上传",
    select: "选择",
    selectAll: "全选",
    clear: "清除",
    apply: "应用",
    update: "更新",
    create: "创建",
    new: "新建",
    viewAll: "查看全部",
    showMore: "显示更多",
    showLess: "显示更少",

    // User
    user: "用户",
    profile: "个人资料",
    settings: "设置",
    logout: "登出",
    login: "登录",
    username: "用户名",
    password: "密码",
    email: "电子邮件",
    phone: "电话",
    name: "姓名",
    id: "ID",

    // Notifications
    notifications: "通知",
    noNotifications: "无通知",

    // Language names
    english: "英语",
    khmer: "高棉语",
    chinese: "中文",
    switchToEnglish: "切换到英文版本",
    switchToChinese: "切换到中文版本",

    // Sections
    administration: "行政管理",
    managementDashboard: "管理仪表板",
    operations: "运营",

    // Module Groups
    accountant: "会计",
    admin: "管理",
    hr: "人力资源",
    csr: "CSR",
    egov: "电子政务",
    qa: "质量保证",
    internalLogistics: "内部物流",
    production: "生产",

    // Modules - Administration
    eInvoicing: "电子发票",
    purchaseRequest: "采购申请",
    yShop: "Y商店",
    supportTicket: "支持工单",
    billRecord: "账单记录",
    gatePass: "通行证",
    meetingRoom: "会议室",
    myCarBooking: "我的车辆预订",
    fireAlarm: "火警",
    cctv: "闭路电视",
    yhr: "YHR",
    salaryBill: "工资单",
    orgChart: "组织架构图",
    training: "培训",
    tempWorkRequest: "临时工作申请",
    speakUp: "Speak Up",
    digitalAudit: "数字审计",
    energy: "能源",
    air: "空气",
    water: "水",
    waste: "废物",
    chemical: "化学品",
    eGovernment: "电子政务",
    systemAnalysis: "系统分析",

    // Modules - Operations
    yqms: "YQMS",
    callOut: "呼叫",
    fc: "FC",
    pwip: "PWIP",
    kanban: "看板",
    ce: "CE",
    ytpm: "YTPM",
    ytmShop: "YTM商店",
    dtSync: "DT同步",
    masterPlan: "主计划",
    linePlan: "生产线计划",
    ppm: "PPM",
    tecPack: "TEC包装",
    pps: "PPS",
    sample: "样品",
    materialPurchase: "材料采购",

    // Sub-modules - YHR
    recruitment: "招聘",
    interview: "面试",
    onboarding: "入职",
    attendant: "考勤",
    benefitProfile: "福利档案",
    payroll: "工资",
    nssf: "NSSF",
    visaAndWorkPermit: "签证和工作许可",
    fwcms: "FWCMS",
    canteen: "食堂",

    // Sub-modules - Training Departments
    onlineTraining: "在线培训",
    yai: "YAI",
    it: "IT",
    shipping: "运输",
    ppc: "PPC",
    merchandising: "商品销售",
    purchasing: "采购",
    generalAffairs: "总务",
    financial: "财务",
    cbsa: "CBSA",
    technical: "技术",
    rawMaterialWarehouse: "原材料仓库",
    cutting: "裁剪",
    scc: "SCC",
    sewing: "缝纫",
    qc: "QC",
    ironing: "熨烫",
    packing: "包装",
    washing: "洗涤",
    tpm: "TPM",
    warehouse: "仓库",
    ie: "IE",
    qaFabric: "QA（面料）",

    // Sub-modules - YTM
    ytm: "YTM",
    machineLocation: "机器位置",
    tv: "TV",
    transfers: "转移",
    setupAndRepair: "设置和维修",
    routineMaintenance: "日常维护",
    systemSetup: "系统设置",
    data: "数据",
    downloadData: "下载",
    analysis: "分析",
    report: "报告",

    // Additional YHR sub-modules
    checklistAttendant: "考勤清单",
    myAttendant: "我的考勤",
    fwcmsPortal: "FWCMS门户",
    ministryOfLabour: "劳动部",

    // Form Labels - Common
    date: "日期",
    time: "时间",
    status: "状态",
    type: "类型",
    category: "类别",
    description: "描述",
    remarks: "备注",
    notes: "注释",
    comment: "评论",
    attachment: "附件",
    file: "文件",
    image: "图片",
    quantity: "数量",
    amount: "金额",
    total: "总计",
    subtotal: "小计",
    unit: "单位",
    unitPrice: "单价",

    // Form Labels - Purchase Request
    purchaseRequisitionForm: "采购申请表",
    purchaseList: "采购清单",
    requester: "申请人",
    requestBy: "申请者",
    department: "部门",
    expectDeliveryDate: "预期交付日期",
    reference: "参考",
    purchaseType: "采购类型",
    topic: "主题",
    paymentType: "付款类型",
    purchaseBy: "采购方式",
    productName: "产品名称",
    productDetails: "产品详情",
    brand: "品牌",
    qty: "数量",
    uom: "计量单位",
    supplier: "供应商",
    localPurchase: "本地采购",
    importPurchase: "进口采购",
    both: "两者",
    newPurchase: "新采购",
    replacement: "更换",
    repair: "维修",
    prePaid: "预付款",
    postPaid: "后付款",
    buyByMyself: "自行购买",
    buyByCompany: "公司购买",
    head: "负责人",
    gm: "总经理",
    purchaser: "采购员",
    stationery: "文具",

    // Form Labels - Support Ticket
    subject: "主题",
    nature: "性质",
    keyword: "关键词",

    // Status
    active: "活跃",
    inactive: "非活跃",
    pending: "待处理",
    approved: "已批准",
    rejected: "已拒绝",
    completed: "已完成",
    inProgress: "进行中",
    cancelled: "已取消",
    comingSoon: "即将推出",

    // Messages
    noData: "无数据",
    noResults: "无结果",
    pleaseWait: "请稍候...",
    areYouSure: "您确定吗？",
    operationSuccessful: "操作成功",
    operationFailed: "操作失败",
    requiredField: "此字段为必填项",
    invalidInput: "输入无效",

    // Time
    today: "今天",
    yesterday: "昨天",
    tomorrow: "明天",
    thisWeek: "本周",
    thisMonth: "本月",
    thisYear: "今年",
    lastWeek: "上周",
    lastMonth: "上月",
    lastYear: "去年",

    // Actions
    viewDetails: "查看详情",
    editItem: "编辑项目",
    deleteItem: "删除项目",
    addNew: "添加新项",
    saveChanges: "保存更改",
    cancelChanges: "取消更改",
    actions: "操作",
    addProduct: "添加产品",
    remove: "移除",

    // Salary Bill Sub-modules
    monthlySalary: "月薪",
    weeklyIncentive: "周激励",
    permitFee: "许可证费",
    resignPayment: "辞职付款",

    // Gate Pass
    visitor: "访客",
    personalRequest: "个人申请",
    materialTransport: "材料运输",
    fixedAssetsTransport: "固定资产运输",
    requestReason: "申请原因",
    whereToGo: "前往地点",
    ymToWh12000: "YM 到 WH12000",
    ymToSubFactory: "YM 到 Sub Factory",
    ymToOther: "YM 到 Other",
    wh12000ToYm: "WH12000 到 YM",
    whToSubFactory: "WH 到 Sub Factory",
    whToOther: "WH 到 Other",
    departureTime: "出发时间",
    returnTime: "返回时间",
    employeeId: "员工ID",
    supervisor: "主管",
    supervisorCode: "主管代码",
    addNewVisitor: "添加新访客",
    officeDuty: "办公职责",
    auditDuty: "审计职责",
    purchaseGoods: "购买商品",
    repairDevice: "维修设备",
    healthIssue: "健康问题",
    personalEmergency: "个人紧急情况",
    other: "其他",

    // Support Ticket Form
    details: "详情",
    uploadImage: "上传图片",
    writeYourThoughts: "在此写下您的想法...",
    imageSizeWarning: "选择照片大小应小于",
    imageFormatWarning: "并且应为",
    format: "格式",
    or: "或",

    // Common Form Fields
    employeeName: "员工姓名",
    jobTitle: "职位",
    position: "岗位",
    joinDate: "入职日期",
    resignDate: "辞职日期",
    workingDays: "工作天数",
    basicSalary: "基本工资",
    allowance: "津贴",
    deduction: "扣除",
    netSalary: "净工资",
    paymentDate: "付款日期",
    period: "期间",
    from: "从",
    to: "到",
    year: "年",
    month: "月",
    week: "周",

    // Gate Pass Table Headers
    no: "编号",
    employeeIdHeader: "员工ID",
    nameHeader: "姓名",
    departmentHeader: "部门",
    supervisorHeader: "主管",
    requestTypeHeader: "申请类型",
    reasonHeader: "原因",
    destination: "目的地",
    departure: "出发",
    return: "返回",
    approve: "批准",
    reject: "拒绝",
    myHistory: "我的历史",
    gpAdmin: "GP-管理员",
    addNewRequest: "添加新申请",
    gatePassRequest: "通行证申请",
    noPendingRequest: "没有待批准的申请",
    allRequestsProcessed: "所有申请已处理",
    employeeInformation: "员工信息",
    yourName: "您的姓名",
    authorizedPersonCode: "授权人代码",
    requestType: "申请类型",
    selectRequestType: "--选择申请类型--",
    selectReason: "--选择原因--",
    timeSchedule: "时间安排",
    submitRequest: "提交申请",
    hour: "小时",
    minute: "分钟",

    // Training
    course: "课程",
    lessons: "课程 (PDF)",
    activity: "活动",
    trainingCourse: "培训课程",
    dashboardVideoTraining: "仪表板视频培训",
    list: "列表",
    calendar: "日历",
    trainer: "培训师",
    category: "类别",
    start: "开始",
    end: "结束",
    trainingLesson: "培训课程",
    listAndScheduleTrainingCourse: "列出和安排培训课程",

    // Accountant Module
    checkRequestLists: "检查申请列表",
    code: "代码",
    return: "返回",
    approveStatus: "批准状态",
    invoice: "发票",
    accCheck: "会计检查",
    productService: "产品/服务",
    requestDate: "申请日期",
    attachDocuments: "附件",
    head: "负责人",
    purchaser: "采购员",
    checked: "已检查",
    pending: "待处理",
    approved: "已批准",
    accPay: "会计付款",
    accApprove: "会计批准",
    payRequestLists: "付款申请列表",
    approvalRequestLists: "批准申请列表",
    searchByCode: "按代码搜索...",
    newData: "新数据",
    oldData: "旧数据",
    requestForm: "申请表",
    pdf: "PDF",
    paid: "已付款",
    by: "由",
    accApprovePay: "会计批准和付款",

    // Recruitment Form
    positionInformation: "职位信息",
    positionTitle: "职位名称",
    employmentType: "雇佣类型",
    recruitmentSource: "招聘来源",
    candidateInformation: "候选人信息",
    fullName: "全名",
    dateOfBirth: "出生日期",
    emailAddress: "电子邮件地址",
    phoneNumber: "电话号码",
    qualificationsExperience: "资格和经验",
    yearsOfExperience: "工作经验年限",
    skillsCompetencies: "技能和能力",
    additionalInformation: "附加信息",
    expectedSalary: "期望薪资",
    availabilityDate: "可入职日期",
    notesComments: "备注和评论",
    saveRecruitment: "保存招聘",
    selectDepartment: "选择部门",
    selectType: "选择类型",
    selectSource: "选择来源",
    selectEducationLevel: "选择教育水平",
    enterFullName: "输入全名",
    enterAddress: "输入地址",
    listRelevantSkills: "列出相关技能和能力",
    additionalNotes: "关于候选人的其他备注或评论",
    fullTime: "全职",
    partTime: "兼职",
    contract: "合同",
    temporary: "临时",
    jobPortal: "招聘网站",
    referral: "推荐",
    socialMedia: "社交媒体",
    recruitmentAgency: "招聘机构",
    walkIn: "直接申请",
    highSchool: "高中",
    associateDegree: "副学士学位",
    bachelorsDegree: "学士学位",
    mastersDegree: "硕士学位",
    phd: "博士学位",
    screening: "筛选中",
    shortlisted: "已入围",
    rejected: "已拒绝",
    hired: "已录用",

    // Interview Form
    interviewArrangement: "面试安排",
    interviewDetails: "面试详情",
    positionApplied: "申请职位",
    interviewDate: "面试日期",
    interviewTime: "面试时间",
    interviewType: "面试类型",
    locationVenue: "地点/场所",
    primaryInterviewer: "主要面试官",
    additionalInterviewers: "其他面试官",
    interviewEvaluation: "面试评估",
    technicalSkills: "技术技能 (1-10)",
    communicationSkills: "沟通技能 (1-10)",
    culturalFit: "文化契合度 (1-10)",
    overallRating: "总体评分 (1-10)",
    strengths: "优势",
    weaknesses: "劣势",
    recommendation: "推荐",
    saveInterview: "保存面试",
    enterCandidateName: "输入候选人姓名",
    meetingRoomOrVideoLink: "会议室或视频链接",
    interviewerName: "面试官姓名",
    commaSeparatedNames: "逗号分隔的姓名",
    phoneScreening: "电话筛选",
    videoInterview: "视频面试",
    inPerson: "面对面",
    panelInterview: "小组面试",
    technicalInterview: "技术面试",
    finalInterview: "最终面试",
    scheduled: "已安排",

    // Onboarding Form
    onboarding: "入职",
    employeeInformation: "员工信息",
    manager: "经理",
    startDate: "开始日期",
    workLocation: "工作地点",
    workSchedule: "工作时间表",
    orientationDate: "入职培训日期",
    orientationCompleted: "入职培训已完成",
    trainingCompleted: "培训已完成",
    systemAccess: "系统访问",
    saveOnboarding: "保存入职",

    // Temp Worker Request Form
    temporaryWorkerRequest: "临时工申请",
    requestor: "申请人",
    genderOfWorker: "工人性别",
    shift: "班次",
    workerType: "工人类型",
    hourlyRate: "时薪",
    startDate: "开始日期",
    endDate: "结束日期",
    reason: "原因",
    selectGender: "选择性别",
    selectOption: "-- 选择选项 --",
    morningShift: "早班",
    afternoonShift: "下午班",
    nightShift: "夜班",
    fullDay: "全天",
    male: "男",
    female: "女",
    other: "其他",
    departmentRequired: "部门为必填项",
    genderRequired: "性别为必填项",
    shiftRequired: "班次为必填项",
    workerTypeRequired: "工人类型为必填项",
    startDateRequired: "开始日期为必填项",
    endDateRequired: "结束日期为必填项",
    reasonRequired: "原因为必填项",
    enterReason: "输入原因",
    selectRating: "选择评分",
    excellent: "优秀",
    good: "良好",
    average: "一般",
    belowAverage: "低于平均",
    poor: "差",
    selectRecommendation: "选择推荐",
    strongHire: "强烈推荐",
    hire: "推荐",
    conditionalHire: "有条件推荐",
    doNotHire: "不推荐",
    rescheduled: "重新安排",
    communicationSkills: "沟通技能 (1-10)",
    maybe: "可能",
    listCandidateStrengths: "列出候选人的优势",
    areasForImprovement: "需要改进的方面",
    listAreasForImprovement: "列出需要改进的方面",
    interviewNotes: "面试笔记",
    detailedInterviewNotes: "详细的面试笔记和观察",
    employeeOnboarding: "员工入职",
    jobDetails: "工作详情",
    reportingManager: "汇报经理",
    managerName: "经理姓名",
    jobTitle: "职位",
    enterFullName: "输入全名",
    employeeAtCompany: "employee@company.com",
    employeeName: "员工姓名",
    officeLocation: "办公地点",
    selectSchedule: "选择时间表",
    mondayFriday: "周一至周五 8AM-5PM",
    mondaySaturday: "周一至周六 8AM-5PM",
    shiftWork: "轮班工作",
    flexible: "灵活",
    salary: "薪资",
    benefits: "福利",
    equipment: "设备",
    documents: "文件",
    orientation: "入职培训",
    training: "培训",
    systemAccess: "系统访问",
    saveOnboarding: "保存入职",
    completed: "已完成",
    cancelled: "已取消",
    benefitsEquipment: "福利和设备",
    benefitsPackage: "福利套餐",
    equipmentAccess: "设备和访问",
    documentsChecklist: "文件和清单",
    requiredDocuments: "必需文件",
    onboardingChecklist: "入职清单",
    systemAccessGranted: "已授予系统访问权限",
    anyAdditionalNotes: "任何其他备注或特殊说明",
    completeOnboarding: "完成入职",
    healthInsurance: "健康保险",
    dentalInsurance: "牙科保险",
    lifeInsurance: "人寿保险",
    retirementPlan: "退休计划",
    paidTimeOff: "带薪休假",
    transportationAllowance: "交通津贴",
    mealAllowance: "餐费津贴",
    laptop: "笔记本电脑",
    desktopComputer: "台式电脑",
    mobilePhone: "手机",
    emailAccount: "电子邮件账户",
    idCard: "身份证",
    accessCard: "门禁卡",
    uniform: "制服",
    idCardCopy: "身份证复印件",
    resumeCv: "简历/CV",
    educationalCertificates: "教育证书",
    previousEmploymentLetter: "前工作证明",
    medicalCertificate: "医疗证明",
    bankAccountDetails: "银行账户详情",
    emergencyContactForm: "紧急联系人表格",
    payrollManagement: "工资管理",
    nssfManagement: "NSSF管理",
    visaWorkPermit: "签证和工作许可",
    canteenMealManagement: "食堂餐食管理",
    payPeriod: "支付周期",
    payDate: "支付日期",
    earnings: "收入",
    basicSalary: "基本工资",
    transportationAllowance: "交通津贴",
    mealAllowance: "餐费津贴",
    housingAllowance: "住房津贴",
    otherAllowance: "其他津贴",
    overtime: "加班",
    overtimeHours: "加班小时",
    overtimeRate: "加班费率",
    overtimeAmount: "加班金额",
    deductions: "扣除",
    tax: "税费",
    socialSecurity: "社会保险",
    bonuses: "奖金",
    performanceBonus: "绩效奖金",
    attendanceBonus: "出勤奖金",
    otherBonus: "其他奖金",
    netPay: "净工资",
    paymentMethod: "支付方式",
    bankAccount: "银行账户",
    selectPeriod: "选择周期",
    monthly: "每月",
    biWeekly: "每两周",
    weekly: "每周",
    enrollmentDate: "注册日期",
    insuranceProvider: "保险公司",
    policyNumber: "保单号",
    coverageType: "保险类型",
    selectCoverage: "选择保险",
    individual: "个人",
    family: "家庭",
    employeeSpouse: "员工+配偶",
    employeeChildren: "员工+子女",
    nationality: "国籍",
    passportNumber: "护照号码",
    passportIssueDate: "护照签发日期",
    passportExpiryDate: "护照到期日期",
    visaType: "签证类型",
    visaNumber: "签证号码",
    visaIssueDate: "签证签发日期",
    visaExpiryDate: "签证到期日期",
    workPermitNumber: "工作许可证号码",
    workPermitIssueDate: "工作许可证签发日期",
    workPermitExpiryDate: "工作许可证到期日期",
    renewalRequired: "需要续签",
    renewalDate: "续签日期",
    active: "有效",
    expired: "已过期",
    mealDate: "用餐日期",
    mealType: "餐食类型",
    selectMealType: "选择餐食类型",
    breakfast: "早餐",
    lunch: "午餐",
    dinner: "晚餐",
    mealOption: "餐食选项",
    quantity: "数量",
    unitPrice: "单价",
    totalAmount: "总金额",
    specialRequests: "特殊要求",
    dietaryRestrictions: "饮食限制",
    dietaryRestrictionsPreferences: "饮食限制和偏好",
    paymentStatus: "支付和状态",
    selectPaymentMethod: "选择支付方式",
    cash: "现金",
    card: "卡",
    mobilePayment: "移动支付",
    nssfMemberNumber: "NSSF会员号码",
    registrationDate: "注册日期",
    contributionPeriod: "缴费周期",
    salaryBase: "工资基数",
    employeeContribution: "员工缴费",
    employerContribution: "雇主缴费",
    totalContribution: "总缴费",
    contributionRate: "缴费率",
    lastPaymentDate: "最后支付日期",
    nextPaymentDate: "下次支付日期",
    current: "当前",
    overdue: "逾期",
    saveBenefitProfile: "保存福利档案",
    savePayroll: "保存工资",
    saveNSSF: "保存NSSF",
    saveVisaWorkPermit: "保存签证和工作许可",
    saveCanteen: "保存食堂订单",
    perHour: "每小时",
    netPayPaymentDetails: "净工资和支付详情",
    bankTransfer: "银行转账",
    check: "支票",
    bankAccountNumber: "银行账户号码",
    bankAccountNumberPlaceholder: "银行账户号码",
    anyAdditionalNotesPayroll: "关于工资的任何其他备注",
    processPayroll: "处理工资",
    departmentName: "部门名称",
    otherDeduction: "其他扣除",
    policyNumberPlaceholder: "保单号",
    insuranceCompany: "保险公司",
    insuranceCompanyName: "保险公司名称",
    provider: "提供商",
    dentalInsuranceCovered: "已覆盖牙科保险",
    lifeInsuranceCovered: "已覆盖人寿保险",
    coverageAmount: "保险金额",
    beneficiary: "受益人",
    beneficiaryName: "受益人姓名",
    retirementPlan: "退休计划",
    enrolledInRetirementPlan: "已注册退休计划",
    planType: "计划类型",
    selectPlan: "选择计划",
    employeeContributionRate: "员工缴费率 (%)",
    employerMatch: "雇主匹配 (%)",
    accountNumber: "账户号码",
    accountNumberPlaceholder: "账户号码",
    paidTimeOff: "带薪休假",
    totalDaysAllocated: "总分配天数",
    daysUsed: "已使用天数",
    remainingDays: "剩余天数",
    carryOverDays: "可结转天数",
    allowances: "津贴",
    otherAllowances: "其他津贴",
    anyAdditionalNotesBenefits: "关于福利的任何其他备注",
    passportInformation: "护照信息",
    issueDate: "签发日期",
    expiryDate: "到期日期",
    expired: "已过期",
    expiringSoon: "即将过期",
    visaInformation: "签证信息",
    selectVisaType: "选择签证类型",
    businessVisa: "商务签证",
    workVisa: "工作签证",
    touristVisa: "旅游签证",
    diplomaticVisa: "外交签证",
    studentVisa: "学生签证",
    visaNumberPlaceholder: "签证号码",
    workPermitInformation: "工作许可证信息",
    workPermitNumberPlaceholder: "工作许可证号码",
    documentsChecklist: "文件清单",
    passportCopy: "护照复印件",
    visaCopy: "签证复印件",
    workPermitCopy: "工作许可证复印件",
    employmentContract: "雇佣合同",
    policeClearance: "无犯罪证明",
    previousWorkPermits: "以前的工作许可证",
    anyAdditionalNotesVisa: "关于签证和工作许可证的任何其他备注",
    mealDetails: "餐食详情",
    selectMeal: "选择餐食",
    confirmed: "已确认",
    prepared: "已准备",
    collected: "已收集",
    anySpecialRequests: "餐食的任何特殊要求或说明",
    anyAdditionalNotesMeal: "关于餐食订单的任何其他备注",
    nssfRegistration: "NSSF注册",
    status: "状态",
    active: "有效",
    suspended: "已暂停",
    terminated: "已终止",
    quarterly: "每季度",
    annually: "每年",
    contributionDetails: "缴费详情",
    contributionRatePercent: "缴费率 (%)",
    nssfBenefits: "NSSF福利",
    eligibleForDisability: "符合残疾福利资格",
    eligibleForDeath: "符合死亡福利资格",
    beneficiaryNamePlaceholder: "受益人姓名",
    coverageAmountPlaceholder: "0.00",
    nssfDocumentsChecklist: "文件清单",
    nssfRegistrationForm: "NSSF注册表",
    idCardCopyNssf: "身份证复印件",
    employmentLetter: "工作证明",
    bankStatement: "银行对账单",
    anyAdditionalNotesNssf: "关于NSSF的任何其他备注",
    pensionPlan: "养老金计划",
    providentFund: "公积金",
    other: "其他",
    beneficiaryNamePlaceholder: "受益人姓名",
    vegetarian: "素食",
    vegan: "纯素",
    halal: "清真",
    noPork: "无猪肉",
    noBeef: "无牛肉",
    noSeafood: "无海鲜",
    glutenFree: "无麸质",
    lowSalt: "低盐",
    noSpicy: "不辣",
    diabeticFriendly: "适合糖尿病患者",
    mealCard: "餐卡",
    monthlyDeduction: "每月扣除",
    companySubsidy: "公司补贴",
    placeOrder: "下单",
    passportNumberPlaceholder: "护照号码",
    workPermitNumberPlaceholder: "工作许可证号码",
    renewalInformation: "续签信息",
    renewed: "已续签",
    paymentStatus: "支付状态",
    paid: "已支付",
    medicalBenefits: "医疗福利",
    eligibleForMedicalBenefits: "符合医疗福利资格",
    coverageStartDate: "保险开始日期",
    coverageEndDate: "保险结束日期",
    retirementBenefits: "退休福利",
    eligibleForRetirementBenefits: "符合退休福利资格",
    accountBalance: "账户余额",
    projectedRetirementDate: "预计退休日期",
    estimatedMonthlyBenefit: "估计月福利",
    disabilityBenefits: "残疾福利",
    deathBenefits: "死亡福利",
    nationalityPlaceholder: "例如：柬埔寨、泰国、越南",
    passportIssueDate: "签发日期",
    passportExpiryDate: "到期日期",
    workPermitIssueDate: "签发日期",
    workPermitExpiryDate: "到期日期",
    passportCopy: "护照复印件",
    visaCopy: "签证复印件",
    workPermitCopy: "工作许可证复印件",
    employmentContract: "雇佣合同",
    medicalCertificate: "医疗证明",
    policeClearance: "无犯罪证明",
    educationalCertificates: "教育证书",
    previousWorkPermits: "以前的工作许可证",
    nssfRegistrationForm: "NSSF注册表",
    idCardCopyNssf: "身份证复印件",
    salaryCertificate: "工资证明",
    bankAccountDetails: "银行账户详情",
    beneficiaryForm: "受益人表格",
    previousNssfRecords: "以前的NSSF记录",
    saveNssfInformation: "保存NSSF信息",
    anyAdditionalNotesNssfRegistration: "关于NSSF注册和福利的任何其他备注",
    meetingRoomBooking: "会议室预订",
    newBooking: "新预订",
    myHistory: "我的历史",
    allBooking: "所有预订",
    totalMeetings: "会议总数",
    ongoing: "进行中",
    upcoming: "即将到来",
    today: "今天",
    filterByStatus: "按状态筛选",
    showing: "显示",
    meetings: "会议",
    meetingInfo: "会议信息",
    organizer: "组织者",
    schedule: "时间表",
    participants: "参与者",
    meetingLink: "会议链接",
    join: "加入",
    view: "查看",
    meetingRoomBookingForm: "会议室预订表",
    yourName: "您的姓名",
    meetingType: "会议类型",
    selectMeetingType: "--选择会议类型--",
    teamMeeting: "团队会议",
    clientPresentation: "客户演示",
    trainingSession: "培训课程",
    projectReview: "项目审查",
    mentionPersonOptional: "提及人员（可选）",
    searchByEmployeeName: "按员工姓名搜索",
    meetingDate: "会议日期",
    startTime: "开始时间",
    endTime: "结束时间",
    meetingLinkOptional: "会议链接（可选）",
    remove: "删除",
    addMeetingLink: "添加会议链接",
    enterMeetingLink: "输入会议链接:",
    selectMeetingRoom: "选择会议室",
    selected: "已选择",
    book: "预订",
    total: "总计",
    request: "请求",
    approved: "已批准",
    cancelled: "已取消",
    bookingForOldPeople: "为老年人预订",
    no: "编号",
    dateTime: "日期/时间",
    numberOfPeople: "人数",
    destination: "目的地",
    driver: "司机",
    driverStatus: "司机状态",
    inProgress: "进行中",
    noDriverAssignedYet: "尚未分配司机",
    share: "分享",
    planYourRoute: "使用交互式地图规划您的路线",
    yourInformation: "您的信息",
    selectUserBooking: "选择用户预订",
    user: "用户",
    code: "代码:",
    routePlanning: "路线规划",
    map: "地图",
    satellite: "卫星",
    gps: "GPS:",
    min: "分钟:",
    clearRoute: "清除路线",
    centerMap: "居中地图",
    showSelected: "显示已选",
    showCar: "显示汽车",
    interactiveMapDisplayed: "交互式地图将在此处显示",
    phnomPenhArea: "金边地区，带位置标记",
    visitorLog: "访客日志",
    printRecords: "打印记录",
    noVisitorRecordsFound: "未找到访客记录。",
    visitorLogNewEntry: "访客日志 - 新条目",
    visitorsName: "访客姓名",
    idCardNo: "身份证号码",
    contactPerson: "联系人",
    purposeOfVisiting: "访问目的",
    visitorCardNo: "访客卡号",
    carCheck: "车辆检查",
    companyName: "公司名称",
    phoneNumber: "电话号码",
    timeIn: "进入时间",
    carMotorPlate: "汽车/摩托车牌照",
    logVisitor: "记录访客",
    checkOut: "退房",
    car: "汽车",
    truck: "卡车",
    qSearchPickUp: "Q 搜索接车地点",
    checklistAttendance: "考勤清单",
    myAttendance: "我的考勤",
    sectionName: "部门名称",
    fromDate: "开始日期",
    toDate: "结束日期",
    employeeName: "员工姓名",
    attendance: "考勤",
    present: "出席",
    absent: "缺席",
    special: "特殊",
    searchEmployee: "搜索员工",
    filter: "筛选",
    attendanceCodes: "考勤代码",
    comeToWork: "上班",
    leaveWithPermission: "请假",
    absentWithoutPermission: "无故缺席",
    sickLeaveOrMaternity: "病假或产检",
    specialLeave: "特殊假期",
    annualLeave: "年假",
    resigned: "已辞职",
    suspendedLeave: "停职",
    maternityLeave: "产假",
    overtime: "加班",
    workOnHoliday: "节假日工作",
    visitorIdNumber: "访客身份证号码",
    timeOut: "离开时间",
    photos: "照片",
    previous: "上一页",
    next: "下一页",
    searchByIDOrName: "按ID或姓名搜索...",
    from: "从",
    to: "到",
    photo: "照片",
    name: "姓名",
    sex: "性别",
    time: "时间",
    morning: "上午",
    evening: "晚上",
    showAttendance: "显示考勤",
    texlinkTechnologies: "TEXLINK TECHNOLOGIES CO., LTD.",
    dailyAttendanceList: "每日考勤表",
    of: "的",
    results: "结果",
    systemAnalyticsDashboard: "系统分析仪表板",
    realtimeInsightsAndPerformanceMetrics: "实时洞察和性能指标",
    activePeriod: "活动期间",
    totalSystemRequests: "系统请求总数",
    networkActivityTracked: "已跟踪网络活动",
    uniqueActiveUsers: "唯一活跃用户",
    engagementMonitored: "已监控参与度",
    yesterday: "昨天",
    last7Days: "最近7天",
    last30Days: "最近30天",
    thisMonth: "本月",
    lastMonth: "上月",
    startDate: "开始日期",
    endDate: "结束日期",
    applyFilter: "应用筛选",
    exportReport: "导出报告",
    realtimeAnalyticsDashboard: "实时分析仪表板",
    moduleRequests: "模块请求",
    userDistribution: "用户分布",
    systemOverview: "系统概览",
    module: "模块",
    totalRequests: "总请求数",
    uniqueUsers: "唯一用户",
    metersDeviceList: "仪表设备列表",
    deviceId: "设备ID",
    location: "位置",
    lastReading: "最后读数",
    energyUsage: "能源使用量",
    online: "在线",
    offline: "离线",
    returnMessage: "退回消息",
    viewReturnDetails: "查看退回详情",
    detail: "详情",
    pdf: "PDF",
    requestForm: "申请表",
    monthlySalary: "月薪",
    payDate: "支付日期",
    earnings: "收入",
    communicationAllowance: "通讯津贴",
    overtimeHours: "加班小时数",
    overtimeRatePerHour: "加班费率（每小时）",
    performanceBonus: "绩效奖金",
    attendanceBonus: "出勤奖金",
    productionBonus: "生产奖金",
    tax: "税",
    nssfContribution: "NSSF缴费",
    salaryAdvance: "预支工资",
    loanDeduction: "贷款扣除",
    salarySummary: "工资摘要",
    grossSalary: "总工资",
    paymentDetails: "支付详情",
    selectMethod: "选择方式",
    bankTransfer: "银行转账",
    cash: "现金",
    check: "支票",
    mobilePayment: "移动支付",
    bankAccountNumberPlaceholder: "银行账号",
    processed: "已处理",
    additionalNotesAboutSalaryPayment: "关于工资支付的其他备注",
    processMonthlySalary: "处理月薪",
    selectMonth: "选择月份",
    january: "一月",
    february: "二月",
    march: "三月",
    april: "四月",
    may: "五月",
    june: "六月",
    july: "七月",
    august: "八月",
    september: "九月",
    october: "十月",
    november: "十一月",
    december: "十二月",
    departmentName: "部门名称",
    jobTitle: "职位",
    shopManagement: "商店管理",
    ticketManagement: "票务管理",
    masterList: "主列表",
    oldData: "旧数据",
    newData: "新数据",
    myRequest: "我的请求",
    requester: "请求者",
    head: "负责人",
    gm: "总经理",
    purchaser: "采购员",
    accountant: "会计师",
    topic: "主题",
    progress: "进度",
    noRequestsFound: "未找到请求",
    confirmReceivedProductService: "确认收到产品/服务",
    confirmReceivedProductServiceList: "确认收到产品/服务列表",
    myReceived: "我收到的",
    requestedBy: "请求者",
    requestDate: "请求日期",
    received: "已收到",
    confirmed: "已确认",
    noApprovedRequestsFound: "未找到已批准的请求",
    weeklyIncentive: "周激励",
    permitFee: "许可证费用",
    resignPayment: "离职付款",
    weekInformation: "周信息",
    weekStartDate: "周开始日期",
    weekEndDate: "周结束日期",
    incentiveType: "激励类型",
    selectType: "选择类型",
    performance: "绩效",
    production: "生产",
    quality: "质量",
    team: "团队",
    combined: "组合",
    incentiveDetails: "激励详情",
    baseAmount: "基础金额",
    performanceMultiplier: "绩效倍数",
    qualityBonus: "质量奖金",
    teamBonus: "团队奖金",
    totalIncentive: "总激励",
    multiplierForBaseAmount: "基础金额倍数（例如，1.0 = 100%，1.5 = 150%）",
    permitInformation: "许可证信息",
    selectPermitType: "选择许可证类型",
    workPermit: "工作许可证",
    visa: "签证",
    residencePermit: "居留许可证",
    businessPermit: "商业许可证",
    professionalLicense: "专业执照",
    permitNumber: "许可证号码",
    permitNumberPlaceholder: "许可证号码",
    issueDate: "签发日期",
    expiryDate: "到期日期",
    feeDetails: "费用详情",
    permitFeeAmount: "许可证费用金额",
    processingFee: "处理费",
    renewalFee: "续期费",
    lateFee: "滞纳金",
    lateFeeIfApplicable: "滞纳金（如适用）",
    totalFee: "总费用",
    paymentDate: "支付日期",
    receiptNumber: "收据号码",
    receiptNumberPlaceholder: "收据号码",
    processPermitFee: "处理许可证费用",
    resignationDate: "辞职日期",
    lastWorkingDate: "最后工作日",
    finalSalary: "最终工资",
    proratedDays: "按比例天数",
    proratedAmount: "按比例金额",
    unusedLeave: "未使用的假期",
    totalDays: "总天数",
    paidDays: "支付天数",
    severancePay: "遣散费",
    noticePeriodPay: "通知期工资",
    totalEarnings: "总收入",
    netPayment: "净付款",
    clearanceStatus: "清算状态",
    processResignPayment: "处理离职付款",
    processWeeklyIncentive: "处理周激励",
    additionalNotesAboutWeeklyIncentive: "关于周激励的任何其他备注",
    companyPaid: "公司支付",
    reimbursed: "已报销",
    cancelled: "已取消",
    unusedLeavePayment: "未使用假期付款",
    totalUnusedLeaveDays: "未使用假期总天数",
    leavePaymentAmount: "假期付款金额",
    additionalPayments: "额外付款",
    equipment: "设备",
    additionalNotesAboutPermitFeePayment: "关于许可证费用支付的其他备注",
    outstandingLoan: "未偿还贷款",
    equipmentAssetRecovery: "设备/资产回收",
    paymentSummary: "付款摘要",
    paymentStatus: "付款状态",
    additionalNotesAboutResignationPayment: "关于离职付款的任何其他备注",
    scheduledTicket: "已安排的票据",
    list: "列表",
    kpi: "KPI",
    ticketsOverview: "票据概览",
    assign: "分配",
    requested: "已请求",
    scheduled: "已安排",
    gaMainTeamProgress: "GA主团队进度",
    toDo: "待办",
    planned: "已计划",
    done: "已完成",
    myTickets: "我的票据",
    timeline: "时间线",
    feedback: "反馈",
    enterYourFeedback: "输入您的反馈...",
    submit: "提交",
    myCarBookings: "我的汽车预订",
    id: "ID",
    destination: "目的地",
    newBooking: "新预订",
    dataList: "数据列表",
    value: "值",
    noDataAvailable: "无可用数据",
    active: "活跃",
    meetingRoomBooking: "会议室预订",
    roomALarge: "房间A（大）",
    roomBSmall: "房间B（小）",
    confHall: "会议厅",
    projectRoom: "项目室",
    teamSync: "团队同步",
    clientCall: "客户电话",
    trainingCourses: "培训课程",
    orientation: "入职培训",
    safety: "安全",
    compliance: "合规",
    technical: "技术",
    softSkills: "软技能",
    leadership: "领导力",
    itSecurity: "IT安全",
    firstAid: "急救",
    qualityControl: "质量控制",
    inventory: "库存",
    customerService: "客户服务",
    management: "管理",
    masterOrganizationChart: "主组织架构图",
    zoomOut: "缩小",
    zoomIn: "放大",
    resetView: "重置视图",
    tip: "提示",
    clickAndDragToPan: "点击并拖动以平移",
    useZoomControlsToAdjustSize: "使用缩放控件调整大小",
    photo: "照片",
    quantity: "数量",
    unit: "单位",
    requestor: "请求者",
    yShop: "Y商店",
    addNewRequest: "添加新请求",
    noRequestsYetClickAddNewRequest: "还没有请求。点击\"添加新请求\"创建一个。",
    view: "查看",
    airQualitySensors: "空气质量传感器",
    goBack: "返回",
    online: "在线",
    sensorNode: "传感器节点",
    temp: "温度",
    humidity: "湿度",
    wasteManagementAnalytics: "废物管理分析",
    totalWaste: "总废物",
    recycled: "回收",
    landfill: "填埋",
    hazardous: "危险",
    composition: "组成",
    plastic: "塑料",
    paper: "纸张",
    monthlyTrend: "月度趋势",
    ref: "参考",
    createdDate: "创建日期",
    planDate: "计划日期",
    finishDate: "完成日期",
    viewImage: "查看图片",
    addRequest: "添加请求",
    looksLikeYouHaveNoRequestsYet: "看起来您还没有请求！",
    needHelpSubmitTicket: "需要帮助？提交票据，我们很乐意为您提供帮助。",
    yes: "是",
    viewSupportTicketImage: "查看支持票据图片",
    addNewSupportRequest: "添加新的支持请求",
    billRecord: "账单记录",
    addBillRecord: "添加账单记录",
    noBillRecordsFound: "未找到账单记录。",
    selectDepartment: "选择部门",
    enterTopic: "输入主题",
    selectCategory: "选择类别",
    enterDescription: "输入描述",
    selectCurrency: "选择货币",
    uploadImage: "上传图片",
    clickToUploadImage: "点击上传图片",
    preview: "预览",
    bill: "账单",
    close: "关闭",
    reset: "重置",
    totalUsers: "总用户数",
    gateInOutRecords: "进出记录",
    motorcycleRecords: "摩托车记录",
    carPlateRecords: "车牌记录",
    truckRecords: "卡车记录",
    walkInOut: "步行进出",
    visitorRecord: "访客记录",
    kYMukTuk: "12K YM Tuk Tuk",
    documentsJoiner: "文档合并器",
    showListsRequest: "显示请求列表",
    masterList: "主列表",
    purchaserWorkspace: "采购员工作区",
    myConfirmReceived: "我的确认收货",
    verifyPR: "验证采购申请",
    approvalPR: "审批采购申请",
    payPR: "支付采购申请",
    tbMonthlyYearly: "月度年度试算表",
    toi: "TOI",
    factoryAccounting: "工厂会计",
    taxReporting: "税务报告",
    checklist6s: "6s检查清单",
    complianceCertificate: "合规证书",
    auditPlan: "审计计划",
    masterOrganizationChart: "主组织架构图",
    customOrganizationChart: "自定义组织架构图",
    leaderWorkerSections: "领导/工人部门",
    faceScanLogs: "人脸扫描日志",
    myFaceScan: "我的人脸扫描",
    solarDashboard: "太阳能仪表板",
    switchBoardAmpereLoadMonitoring: "开关板安培负载监控",
    energySource: "能源来源",
    temperatureHumiditySensor: "温湿度传感器",
    switchFanPump: "开关（风扇和泵）",
    airQualityDetector: "空气质量检测器",
    requestWorkerForm: "请求工人表单",
    requestWorkerList: "请求工人列表",
    cambodiaEInvoice: "柬埔寨电子发票",
    supplierManagement: "供应商管理",
    iews: "IEWS",
    qcFile: "QC文件",
    preProductionMeeting: "生产前会议",
    firstOutputCutting: "首次产出裁剪",
    firstOutputPrintingEmbroidery: "首次产出印花刺绣",
    firstOutputSewing: "首次产出缝纫",
    qaCutting: "QA裁剪",
    qaPrintingEmbroidery: "QA印花刺绣",
    qa20pcsAudit: "QA 20件审计",
    inlineAuditRolling: "在线审计滚动",
    offlineAudit: "离线审计",
    qcEndLineChecking: "QC终线检查",
    internalRollingQC: "内部滚动QC",
    cuttingInspection: "裁剪检验",
    cutPanelInspection: "裁片检验",
    printingInspection: "印花检验",
    embroideryInspection: "刺绣检验",
    garmentCheckOutput: "成衣检查产出",
    finishingInspection: "整理检验",
    ironingInspection: "熨烫检验",
    packingInspection: "包装检验",
    preFinalInspection: "预最终检验",
    finalInspection: "最终检验",
    buyerFinalInspection: "买家最终检验",
    supplierEvaluation: "供应商评估",
    customerComplainCap: "客户投诉上限",
    fabricReceiving: "面料接收",
    fabricInspection: "面料检验",
    fabricTest: "面料测试",
    consumptions: "消耗量",
    calculator: "计算器",
    fabricIssuing: "面料发放",
    deliveryTracking: "交付跟踪",
    returnFabric: "退回面料",
    returnAccessories: "退回辅料",
    brandProtection: "品牌保护",
    onlineTraining: "在线培训",
    shipping: "运输",
    ppc: "PPC",
    merchandising: "商品销售",
    purchasing: "采购",
    generalAffairs: "总务",
    financial: "财务",
    cbsa: "CBSA",
    sample: "样品",
    technical: "技术",
    rawMaterialWarehouse: "原材料仓库",
    scc: "SCC",
    tpm: "TPM",
    warehouse: "仓库",
    ie: "IE",
    qaFabric: "QA（面料）",
    production: "生产",
    dashboard: "仪表板",
    report: "报告",
    ccf: "CCF",
    misti: "MISTI",
    owso: "OWSO",
    eFiling: "电子归档",
    nssf: "NSSF",
    preProduction: "生产前",
    firstOutput: "首次产出",
    cut: "裁剪",
    washing: "洗涤",
    rainWaterCollect: "雨水收集",
    building1: "建筑1",
    building2: "建筑2",
    building3: "建筑3",
    staffRoom: "员工室",
    directProductionWaste: "直接生产废物",
    generalWaste: "一般废物",
    addWaste: "添加废物",
    useWaste: "使用废物",
    quantityKg: "数量（公斤）",
    wasteKg: "废物（公斤）",
    preAudit: "审计前",
    onSiteAudit: "现场审计",
    reporting: "报告",
    reportingAssessment: "报告与评估",
    postAudit: "审计后",
    inProgress: "进行中",
    activityAuditPlan: "活动审计计划",
    trackTheProgress: "跟踪每个阶段的审计活动进度",
    viewAuditPlan: "查看审计计划",
    addAuditPlan: "添加审计计划",
    auditPlanList: "审计计划列表",
    auditDetails: "审计详情",
    totalReports: "总计",
    reports: "报告",
    planningPreparation: "规划与准备",
    verificationFinal: "验证与最终",
    syncToDrive: "同步到云端硬盘",
    allAudits: "所有审计",
    addAudit: "添加审计",
    import: "导入",
    export: "导出",
    editAudit: "编辑审计",
    explanation: "说明",
    sourceConsulted: "咨询来源",
    legalReference: "法律依据",
    contents: "内容",
    issue: "问题",
    attachments: "附件",
    seeMore: "查看更多",
    temperatureHumiditySensorDeviceList: "温湿度传感器设备列表",
    newBoiler: "新锅炉",
    pressing: "熨烫",
    airCompressor: "空压机",
    secondarySP: "二级SP",
    rawPileSource: "原料堆源",
    oilbox: "油箱",
    generator: "发电机",
    coolingSystem: "冷却系统",
    heatingUnit: "加热单元",
    ventilation: "通风",
    lightingSystem: "照明系统",
    motorA: "电机A",
    motorB: "电机B",
    pumpSystem: "泵系统",
    compressor2: "压缩机2",
    boiler2: "锅炉2",
    turbine: "涡轮机",
    transformer: "变压器",
    switchGear: "开关设备",
    controlPanel: "控制面板",
    device: "设备",
    fabricInspection: "面料检验",
    fabricWHD: "面料WHD",
    qaRoom: "QA室",
    assemblingRoom: "装配室",
    supervisorRoom: "主管室",
    fabricFolding: "面料折叠",
    deliverallyRoom: "交付室",
    sewingC: "缝纫C",
    windingDept: "卷绕部门",
    fabricReleasing: "面料发放",
    uggirSewingB: "UGGIR缝纫B",
    rcc: "RCC",
    sewingA: "缝纫A",
    finishGoodsWHD: "成品WHD",
    example: "示例",
    cartonKeepingArea: "纸箱存放区",
    finishing: "整理",
    directProductionWasteCutting: "直接生产废物（裁剪）",
    directProductionWasteSewing: "直接生产废物（缝纫）",
    generalWasteOrganicWaste: "一般废物（有机废物）",
    generalWasteConfused: "一般废物（混淆）",
    wasteProductAnalytics: "废物产品分析",
    exportAsPDF: "导出为PDF",
    showing: "显示",
    onThisPage: "在此页面上",
    auditLocation: "审计地点",
    auditForm: "审计表单",
    activityProcessFlow: "活动流程",
    noAuditPlansFound: "未找到审计计划",
    meters: "仪表",
    metersDeviceList: "仪表设备列表",
    exportAllMetersRecord: "导出所有仪表记录",
    hourlyReport: "小时报告",
    totalDevice: "设备总数",
    totalEnergyConsumed: "总能耗",
    energyConsumedA: "能耗A",
    energyConsumedB: "能耗B",
    energyConsumedC: "能耗C",
    energyConsumedD: "能耗D",


    // YQMS
    finCheckSetting: "Fincheck 设置",
    finCheckUpload: "Fincheck 上传",
    finCheckTemplate: "Fincheck 模板",
    finCheckReport: "Fincheck 报告",
    finCheckInspection: "Fincheck 检查",
    P88Legacy: "P88 Legacy",

    // Energy - Switch Board
    switchBoardList: "开关板列表",
    switchBoards: "开关板",
    monitorAllRegisteredSwitchBoards: "一目了然地监控所有已注册的开关板及其连接的设备。",
    importExcel: "导入 Excel",
    addSwitchBoard: "添加开关板",
    viewDetails: "查看详情",
    equipmentCount: "设备数量",
    totalSwitchBoards: "开关板总数",
    totalEquipments: "设备总数",
    averageEquipments: "平均设备数 / 板",

    // Air - Air Quality Detector
    airQualityDetectorDeviceList: "空气质量检测器设备列表",

    // Waste - Boiler
    boiler: "锅炉",
    addBoiler: "添加锅炉",
    export: "导出",
    steamBoiler: "蒸汽锅炉",
    hotWaterBoiler: "热水锅炉",
    wasteHeatBoiler: "废热锅炉",
    electricBoiler: "电锅炉",
    totalBoiler: "锅炉总数",
    daysTracked: "跟踪天数",

    // Digital Audit - Compliance Certificate
    complianceCertificate: "合规证书",
    search: "搜索",
    reset: "重置",
    ministryType: "部门类型",
    auditType: "审计类型",
    all: "全部",
    certificateName: "证书名称",
    ministry: "部门",
    issueDate: "签发日期",
    expiredDate: "到期日期",
    validityPeriod: "有效期",
    renewalDate: "续期日期",
    responsiblePerson: "负责人",
    valid: "有效",
    expired: "已过期",
    viewCertificate: "查看证书",
    noCertificatesFound: "未找到证书",

    // Purchase Request - Approval
    requestDetails: "请求详情",
    approvalApplicationList: "批准申请列表",
    accountantApproval: "会计批准",
    accountantApprovalAndPayment: "会计批准和付款",
    approvedAndPaid: "已批准 & 已支付",

    // Call Out / KANBAN
    allLocation: "所有位置",
    refresh: "刷新",
    exit: "退出",
    line1: "生产线 1",
    line2: "生产线 2",
    line3: "生产线 3",
    line4: "生产线 4",
    line5: "生产线 5",
    line6: "生产线 6",
    line7: "生产线 7",
    line8: "生产线 8",
    line9: "生产线 9",
    line10: "生产线 10",
    line11: "生产线 11",

    // CE Module
    stStandardTime: "ST标准时间",
    productDevelopment: "产品开发",
    garmentAnalysis: "服装分析",
    cutSewPackProductivity: "裁剪、缝纫、包装生产力",
    machineAllocation: "机器分配",
    skillInventory: "技能清单",
    teamPerformance: "团队绩效",
    learningCurve: "学习曲线",
    downtimes: "停机时间",
    costCentersDirectIndirectCost: "成本中心，直接/间接成本",
    cpm: "CPM",
    styleCosting: "款式成本",

    // FC Module
    accessoriesReceiving: "辅料接收",
    accessoriesInspection: "辅料检验",
    accessoriesIssuing: "辅料发放",
    warehouseTrackingLocation: "仓库跟踪位置",

    // YQMS - Final Production
    qaAuditFinishingPacking: "QA审计整理包装",
    humidityAquaboyChecking: "湿度Aquaboy检查",
    firstOutputFinishingAndPacking: "首次产出整理和包装",

    // Compliance Certificate - Additional
    certificateAndReport: "证书和报告",
    typeOfMinistries: "部门类型",
    searchByCertificateIdOrName: "按证书ID或名称搜索",
    fromDate: "开始日期",
    toDate: "结束日期",
    ministryPermits: "部门许可",
    addCertificate: "添加证书",
    importPermits: "导入许可",
    history: "历史记录",
    exportPermits: "导出许可",
    certificatesList: "证书列表",
    totalCertificates: "总计",
    showingOnThisPage: "显示",
    onThisPage: "在此页面上",
    notAvailable: "不适用",
    viewPdf: "查看PDF",
    certificateImage: "证书图像",
    ministrySupplier: "部门/供应商",
    actions: "操作",
    status: "状态",
    showingResults: "显示",
    to: "到",
    of: "共",
    year: "年",
    years: "年",
    days: "天",
    certificate: "证书",
    certificates: "证书",
    board: "板",
    equipments: "设备",

    // Water Module
    waterProductList: "水产品列表",
    totalWaterConsumed: "总耗水量",
    waterMeter: "水表",

    // Phone Viewer
    phoneScreenshots: "手机截图",
    images: "图片",
    useArrowKeys: "使用箭头键或按钮导航",
    homePage: "首页",
    web: "网页",
    selectModule: "选择一个模块查看手机截图"
};

export default translations;
